import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0c] border-t border-white/10 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Wordmark size="text-3xl" />
          <p className="mt-4 text-[#8a8d91] max-w-sm font-body">
            Perth's premiere JDM and custom car culture show. Static displays, exhibitor stands, live entertainment and People's Choice voting.
          </p>
          <div className="flex items-center gap-3 mt-5">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#b026ff] hover:text-[#b026ff] transition-colors" aria-label="social">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-heading uppercase tracking-wide text-sm text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-[#8a8d91] font-body text-sm">
            <li><Link to="/main-event" className="hover:text-[#ff7a1a]">Main Event</Link></li>
            <li><Link to="/mini-salons" className="hover:text-[#ff7a1a]">Mini Salons</Link></li>
            <li><Link to="/exhibitors" className="hover:text-[#ff7a1a]">Exhibitors</Link></li>
            <li><Link to="/sponsors" className="hover:text-[#ff7a1a]">Sponsors</Link></li>
            <li><Link to="/app" className="hover:text-[#ff7a1a]">Event App</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading uppercase tracking-wide text-sm text-white mb-4">Venue</h4>
          <p className="text-[#8a8d91] font-body text-sm flex gap-2">
            <MapPin size={16} className="mt-0.5 text-[#ff7a1a] shrink-0" />
            Perth Convention and Exhibition Centre, 21 Mounts Bay Rd, Perth WA 6000
          </p>
          <p className="text-white font-heading mt-4 uppercase">2027 · Dates to be announced</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#8a8d91] font-body">
        © 2027 Perth Auto Salon. A Signature Marketing production. All rights reserved.
      </div>
    </footer>
  );
}
